<nz-card class="flow-card" nzTitle="IHS Order">
    <p class="flow-card__subtitle">Complete the IHS order, then enter the order number below.
    </p>

    <nz-spin [nzSpinning]="loading">
        <div class="docs-sections">
            <section class="docs-section" *ngIf="disclosures.length">
                <h4>Disclosures</h4>
                <div class="docs-content">
                    <p *ngFor="let d of disclosures">{{ d }}</p>
                </div>
            </section>
        </div>
        <div class="order-link-row" *ngIf="ihsUrl">
            <button nz-button nzType="primary" nzSize="large" (click)="openIhs()">
                <span nz-icon nzType="link"></span>
                Open IHS Order Page
            </button>
        </div>

        <form nz-form [formGroup]="orderForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
            <nz-form-item class="flow-form__item">
                <nz-form-label [nzRequired]="true" nzFor="ihsOrderNumber">IHS Order Number</nz-form-label>
                <nz-form-control>
                    <input nz-input id="ihsOrderNumber" formControlName="ihsOrderNumber"
                        placeholder="Enter order number" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="flow-form__item">
                <nz-form-control [nzValidateStatus]="orderForm.get('disclosuresAccepted')">
                    <label nz-checkbox formControlName="disclosuresAccepted">
                        I have read and understand the disclosures above.
                    </label>
                </nz-form-control>
                <nz-form-explain
                    *ngIf="orderForm.get('disclosuresAccepted')?.touched && orderForm.get('disclosuresAccepted')?.errors?.['required']">
                    You must accept the disclosures to continue.
                </nz-form-explain>
            </nz-form-item>

            <div class="flow-actions flow-actions--trailing">
                <button nz-button nzType="primary" [disabled]="orderForm.invalid" (click)="submit()">
                    Continue
                </button>
            </div>
        </form>
    </nz-spin>
</nz-card>